<template>
  <div class="geneticas-page container-fluid mt-4">
    <div class="funcionalidad-container shadow-sm p-3 bg-white rounded">
      <!-- Título principal y botón para crear genética -->
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
        <h2 class="mb-0 fs-4 fs-md-2">
          <font-awesome-icon icon="fas fa-dna" class="me-2" />
          Genéticas del Club
        </h2>
          <button @click="abrirModalAlta" class="btn btn-success btn-lg btn-md btn-sm mt-2 mt-md-0 w-100 w-md-auto">
          <font-awesome-icon icon="fas fa-plus" class="me-1" /> Crear Genética
        </button>
      </div>

      <!-- Filtros -->
      <div class="filters mb-3">
        <div class="row g-2 flex-column flex-md-row">
          <div class="col-12 col-md-3">
            <input
              v-model="filterNombre"
              type="text"
              class="form-control form-control-lg"
              placeholder="Buscar por nombre"
            />
          </div>
          <div class="col-12 col-md-3">
            <select v-model="filterTipoCannabis" class="form-select form-select-lg">
              <option value="">Todos los tipos de cannabis</option>
              <option v-for="tipo in tiposCannabis" :key="tipo" :value="tipo">
                {{ tipo }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-3">
            <select v-model="filterTipoOrigen" class="form-select form-select-lg">
              <option value="">Todos los tipos de origen</option>
              <option v-for="origen in origenes" :key="origen" :value="origen">
                {{ origen }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-3">
            <button class="btn btn-secondary btn-lg w-100" @click="limpiarFiltros">
              Limpiar Filtros
            </button>
          </div>
        </div>
      </div>

      <!-- Tabla de genéticas (solo visible en md+) -->
      <div class="table-responsive d-none d-md-block">
        <table class="table table-striped table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th @click="ordenar('nombre')" style="cursor:pointer">
                Nombre <font-awesome-icon :icon="iconoOrden('nombre')" />
              </th>
              <th>Descripción</th>
              <th @click="ordenar('thc')" style="cursor:pointer">
                THC (%) <font-awesome-icon :icon="iconoOrden('thc')" />
              </th>
              <th @click="ordenar('cbd')" style="cursor:pointer">
                CBD (%) <font-awesome-icon :icon="iconoOrden('cbd')" />
              </th>
              <th>Tipo Origen</th>
              <th>Tipo Cannabis</th>
              <th>Floración (días)</th>
              <th>Rendimiento</th>
              <th>Tipo Resina</th>
              <th>Perfil Aromático</th>
              <th>Perfil Terpenos</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="gen in geneticasFiltradas" :key="gen.id">
              <td>{{ gen.nombre }}</td>
              <td>{{ gen.descripcion }}</td>
              <td>{{ gen.thc }}%</td>
              <td>{{ gen.cbd }}%</td>
              <td>{{ gen.tipo_origen }}</td>
              <td>{{ gen.tipo_cannabis }}</td>
              <td>{{ gen.tiempo_floracion }}</td>
              <td>{{ gen.rendimiento }}</td>
              <td>{{ gen.tipo_resina }}</td>
              <td>{{ gen.perfil_aromatico }}</td>
              <td>{{ gen.perfil_terpenos }}</td>
              <td>
                <button
                  @click="mostrarComponente('editar', gen)"
                  class="btn btn-sm btn-outline-primary me-1"
                >
                  <font-awesome-icon icon="fas fa-edit" />
                </button>
                <button
                  @click="mostrarComponente('eliminar', gen)"
                  class="btn btn-sm btn-outline-danger"
                >
                  <font-awesome-icon icon="fas fa-trash-alt" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Cards responsivas para mobile (solo visible en sm-) -->
      <div class="d-block d-md-none">
        <div class="row row-cols-1 g-3">
          <div v-for="gen in geneticasFiltradas" :key="gen.id" class="col">
            <div class="card shadow-sm h-100">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h5 class="card-title mb-0">{{ gen.nombre }}</h5>
                  <div>
                    <button
                      @click="mostrarComponente('editar', gen)"
                      class="btn btn-outline-primary btn-sm me-1"
                      aria-label="Editar genética"
                    >
                      <font-awesome-icon icon="fas fa-edit" />
                    </button>
                    <button
                      @click="mostrarComponente('eliminar', gen)"
                      class="btn btn-outline-danger btn-sm"
                      aria-label="Eliminar genética"
                    >
                      <font-awesome-icon icon="fas fa-trash-alt" />
                    </button>
                  </div>
                </div>
                <p class="card-text small text-muted mb-1">{{ gen.descripcion }}</p>
                <div class="row g-1">
                  <div class="col-6">
                    <span class="fw-bold">THC:</span> {{ gen.thc }}%
                  </div>
                  <div class="col-6">
                    <span class="fw-bold">CBD:</span> {{ gen.cbd }}%
                  </div>
                  <div class="col-6">
                    <span class="fw-bold">Tipo:</span> {{ gen.tipo_cannabis }}
                  </div>
                  <div class="col-6">
                    <span class="fw-bold">Origen:</span> {{ gen.tipo_origen }}
                  </div>
                  <div class="col-6">
                    <span class="fw-bold">Floración:</span> {{ gen.tiempo_floracion }} días
                  </div>
                  <div class="col-6">
                    <span class="fw-bold">Rendimiento:</span> {{ gen.rendimiento }}
                  </div>
                  <div class="col-12 mt-1">
                    <span class="fw-bold">Resina:</span> {{ gen.tipo_resina }}
                  </div>
                  <div class="col-12">
                    <span class="fw-bold">Aroma:</span> {{ gen.perfil_aromatico }}
                  </div>
                  <div class="col-12">
                    <span class="fw-bold">Terpenos:</span> {{ gen.perfil_terpenos }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para AltaGenetica -->
    <div v-if="mostrarModalAlta">
      <div class="modal fade show" tabindex="-1" style="display: block; z-index: 1055;" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Crear Genética</h5>
              <button type="button" class="btn-close" @click="cerrarModalAlta" aria-label="Cerrar"></button>
            </div>
            <div class="modal-body">
              <AltaGenetica :club_id="clubActual.id" @accionTerminada="onAltaTerminada" />
            </div>
          </div>
        </div>
      </div>
      <!-- Backdrop -->
      <div class="modal-backdrop fade show" style="z-index: 1050;" @click="cerrarModalAlta"></div>
    </div>

    <!-- Modal para EditarGenetica -->
    <div v-if="mostrarModalEditar">
      <div class="modal fade show" tabindex="-1" style="display: block; z-index: 1055;" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Editar Genética</h5>
              <button type="button" class="btn-close" @click="cerrarModalEditar" aria-label="Cerrar"></button>
            </div>
            <div class="modal-body">
              <EditarGenetica :genetica="geneticaEnAccion" :club_id="clubActual.id" @accionTerminada="onEditarTerminada" />
            </div>
          </div>
        </div>
      </div>
      <!-- Backdrop -->
      <div class="modal-backdrop fade show" style="z-index: 1050;" @click="cerrarModalEditar"></div>
    </div>

    <!-- Modal para EliminarGenetica -->
    <div v-if="mostrarModalEliminar">
      <div class="modal fade show" tabindex="-1" style="display: block; z-index: 1055;" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Eliminar Genética</h5>
              <button type="button" class="btn-close" @click="cerrarModalEliminar" aria-label="Cerrar"></button>
            </div>
            <div class="modal-body">
              <EliminarGenetica :genetica="geneticaEnAccion" :club_id="clubActual.id" @accionTerminada="onEliminarTerminada" @cancelar="cerrarModalEliminar" />
            </div>
          </div>
        </div>
      </div>
      <!-- Backdrop -->
      <div class="modal-backdrop fade show" style="z-index: 1050;" @click="cerrarModalEliminar"></div>
    </div>

    <!-- Componente dinámico (eliminar) -->
    <component
      v-if="componenteActivo && componenteActivo !== 'alta' && componenteActivo !== 'editar'"
      :is="componenteActivo"
      :genetica="geneticaEnAccion"
      :club_id="club_id"
      @accionTerminada="accionCompletada"
      class="mt-3"
    />
  </div>
</template>

<script>
import axios from "@/axios";
import AltaGenetica from "./alta-genetica.vue";
import EditarGenetica from "./editar-genetica.vue";
import EliminarGenetica from "./eliminar-genetica.vue";

export default {

  components: {
    AltaGenetica,
    EditarGenetica,
    EliminarGenetica,
  },
  data() {
    return {
      clubActual: this.$store.getters.getClubActual,
      geneticas: [],
      componenteActivo: null, // Ya no se usa para eliminar
      geneticaEnAccion: null, // Genética en acción para editar o eliminar
      mostrarModalAlta: false, // Controla el modal de alta
      mostrarModalEditar: false, // Controla el modal de editar
      mostrarModalEliminar: false, // Controla el modal de eliminar
      // Filtros
      filterNombre: "",
      filterTipoCannabis: "",
      filterTipoOrigen: "",
      // Ordenamiento
      sortColumn: "",
      sortOrder: "asc",
      // Constantes para filtros
      origenes: [],
      tiposCannabis: [],
    };
  },
  computed: {
    geneticasFiltradas() {
      let list = this.geneticas;
      if (this.filterNombre) {
        list = list.filter((gen) =>
          gen.nombre.toLowerCase().includes(this.filterNombre.toLowerCase())
        );
      }
      if (this.filterTipoCannabis) {
        list = list.filter((gen) => gen.tipo_cannabis === this.filterTipoCannabis);
      }
      if (this.filterTipoOrigen) {
        list = list.filter((gen) => gen.tipo_origen === this.filterTipoOrigen);
      }
      if (this.sortColumn) {
        list = [...list].sort((a, b) => {
          let aVal = a[this.sortColumn];
          let bVal = b[this.sortColumn];
          if (typeof aVal === "string") {
            aVal = aVal.toLowerCase();
            bVal = bVal.toLowerCase();
          }
          if (aVal < bVal) return this.sortOrder === "asc" ? -1 : 1;
          if (aVal > bVal) return this.sortOrder === "asc" ? 1 : -1;
          return 0;
        });
      }
      return list;
    },
  },
  async created() {
    await this.cargarGeneticas();
    await this.cargarConstantes();
  },
  methods: {
    async cargarGeneticas() {
      try {
        const response = await axios.get(`/api/geneticasPorClub/${this.clubActual.id}`);
        this.geneticas = response.data;
      } catch (error) {
        console.error("Error al obtener las genéticas:", error);
      }
    },
    async cargarConstantes() {
      try {
        // Cargamos los arrays para los filtros desde los endpoints correspondientes
        const [origenRes, tipoCannabisRes] = await Promise.all([
          axios.get("/api/constantes/origen_genetica_cannabis"),
          axios.get("/api/constantes/tipos_cannabis"),
        ]);
        this.origenes = origenRes.data;
        this.tiposCannabis = tipoCannabisRes.data;
      } catch (error) {
        console.error("Error al cargar las constantes:", error);
      }
    },
    mostrarComponente(tipo, genetica = null) {
      if (tipo === "crear") {
        this.abrirModalAlta();
        return;
      }
      if (tipo === "editar") {
        this.abrirModalEditar(genetica);
        return;
      }
      if (tipo === "eliminar") {
        this.abrirModalEliminar(genetica);
        return;
      }
    },
    abrirModalAlta() {
      this.mostrarModalAlta = true;
    },
    cerrarModalAlta() {
      this.mostrarModalAlta = false;
    },
    async onAltaTerminada() {
      this.cerrarModalAlta();
      await this.cargarGeneticas();
    },
    abrirModalEditar(genetica) {
      this.geneticaEnAccion = genetica;
      this.mostrarModalEditar = true;
    },
    cerrarModalEditar() {
      this.mostrarModalEditar = false;
      this.geneticaEnAccion = null;
    },
    async onEditarTerminada() {
      this.cerrarModalEditar();
      await this.cargarGeneticas();
    },
    abrirModalEliminar(genetica) {
      this.geneticaEnAccion = genetica;
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.geneticaEnAccion = null;
    },
    async onEliminarTerminada() {
      this.cerrarModalEliminar();
      await this.cargarGeneticas();
    },
    async accionCompletada() {
      this.componenteActivo = null;
      this.geneticaEnAccion = null;
      await this.cargarGeneticas();
    },
    ordenar(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column;
        this.sortOrder = "asc";
      }
    },
    iconoOrden(column) {
      if (this.sortColumn !== column) return "fas fa-sort";
      return this.sortOrder === "asc" ? "fas fa-sort-up" : "fas fa-sort-down";
    },
    limpiarFiltros() {
      this.filterNombre = "";
      this.filterTipoCannabis = "";
      this.filterTipoOrigen = "";
    },
  },
};
</script>

<style scoped>
.geneticas-page {
  padding: 10px;
  background-color: #f7f8fa;
}

.filters input,
.filters select {
  width: 100%;
  font-size: 1.1rem;
}

.table-responsive {
  margin-top: 20px;
}

.table th,
.table td {
  vertical-align: middle;
}

.modal {
  z-index: 1055;
}
.modal-backdrop {
  z-index: 1050;
}

@media (max-width: 767.98px) {
  .geneticas-page {
    padding: 4px;
  }
  .funcionalidad-container {
    padding: 8px !important;
  }
  .filters .form-control-lg,
  .filters .form-select-lg {
    font-size: 1rem;
    padding: 0.5rem 0.75rem;
  }
  .btn-lg {
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
  h2.fs-4 {
    font-size: 1.3rem !important;
  }
  .card-title {
    font-size: 1.1rem;
  }
  .card-text {
    font-size: 0.95rem;
  }
}
</style>
